import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {Grid, TextField, Typography} from '@material-ui/core'

import {IRegisterRequestParams} from '../../interfaces/api'
import BackButton from '../Common/BackButton'
import NextButton from '../Common/NextButton'
import BootstrapInput from '../Common/BootstrapInput'
import FormControl from '@material-ui/core/FormControl';
import SuhaGridItem from "../Suha/SuhaGridItem";
import SuhaBare from "../Suha/SuhaBare";
import SuhaBubble from "../Suha/SuhaBubbleSmall";

import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const useStyles = makeStyles((theme) => ({
    mt3: {
        marginTop: 40,
        marginBottom: 20,
    },
    root: {
        padding: '2vh 5vw',
    },
}))

interface IAccountFormProps {
    userInfo: IRegisterRequestParams
    setUserInfo: (info: IRegisterRequestParams) => void
    handleNext: any
    handlePrev: any
    errors: any[]

    setErrors(values: any[]): void

    handleValidation(): void
}

export default function AccountForm(props: IAccountFormProps) {
    const classes = useStyles()
    const [showPassword, setShowPassword] = React.useState(false);
    const [showPassword2, setShowPassword2] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {event.preventDefault();};
    const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {event.preventDefault();};
    const handleClickShowPassword2 = () => setShowPassword2((show) => !show);
    const handleMouseDownPassword2 = (event: React.MouseEvent<HTMLButtonElement>) => {event.preventDefault();};
    const handleMouseUpPassword2 = (event: React.MouseEvent<HTMLButtonElement>) => {event.preventDefault();};
    return (
        <React.Fragment>
            <form noValidate>
                <Grid container className={classes.root} direction={"row"} justifyContent={"center"} justify={"center"}
                      alignItems={"flex-start"}>
                    <Grid item xs={3} container direction={"column"} justifyContent={"flex-start"} justify={"flex-start"}
                          alignItems={"flex-start"}>
                        <Grid item xs={12}>
                            <BackButton show_button={true} handleClick={props.handlePrev}/>
                        </Grid>
                    </Grid>
                    <Grid item xs={9}  style={{justifyContent:"center", alignItems:"center"}}>
                        <SuhaBubble position={0}/>
                    </Grid>
                    <Grid item sm={7} xs={12}>
                        <Typography gutterBottom>
                            First, what should Suha call you?
                        </Typography>
                    </Grid>
                    <Grid item sm={7} xs={12}>
                        <FormControl fullWidth>
                            <BootstrapInput
                                name="nickName"
                                id="nickName"
                                placeholder="Type Name"
                                value={props.userInfo.nickName}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    props.setUserInfo({
                                        ...props.userInfo,
                                        nickName: e.currentTarget.value,
                                    })
                                }/>
                        </FormControl>
                    </Grid>
                    <Grid item sm={7} xs={12}>
                        <Typography gutterBottom className={classes.mt3}>
                            Please create a password.
                        </Typography>
                    </Grid>
                    <Grid item sm={7} xs={12} style={{marginBottom: 10}}>
                        <FormControl fullWidth>
                            <BootstrapInput
                                name="password"
                                id="password"
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Type Password"
                                value={props.userInfo.password}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    props.setUserInfo({
                                        ...props.userInfo,
                                        password: e.currentTarget.value,
                                    })
                                }
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={
                                                showPassword ? 'hide the password' : 'display the password'
                                            }
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            onMouseUp={handleMouseUpPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <Grid item></Grid>
                    </Grid>
                    <Grid item sm={7} xs={12}>

                        <FormControl fullWidth>
                            <BootstrapInput
                                name="passwordConfirmation"
                                id="passwordConfirmation"
                                type={showPassword2 ? 'text' : 'password'}
                                placeholder="Type Confirm Password"
                                value={props.userInfo.passwordConfirmation}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    props.setUserInfo({
                                        ...props.userInfo,
                                        passwordConfirmation: e.currentTarget.value,
                                    })
                                }endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={
                                            showPassword2 ? 'hide the password' : 'display the password'
                                        }
                                        onClick={handleClickShowPassword2}
                                        onMouseDown={handleMouseDownPassword2}
                                        onMouseUp={handleMouseUpPassword2}
                                        edge="end"
                                    >
                                        {showPassword2 ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }/>
                        </FormControl>
                    </Grid>
                    <Grid item sm={7} xs={12}>
                        <NextButton handleClick={props.handleNext}/>
                    </Grid>
                </Grid>
            </form>
        </React.Fragment>
    )
}
